import { useQuery } from '@apollo/client';

import { CompaniesIndustriesDocument } from '../../graphql/queries/companies-industries.gql-types';

const DEFAULT_ORDER = 'TOTAL';

type CompaniesIndustriesProps = {
  limit: number;
};

const useCompaniesIndustries = ({ limit = 4 }: CompaniesIndustriesProps) => {
  const { error, ...rest } = useQuery(CompaniesIndustriesDocument, {
    variables: {
      limit,
      // @ts-expect-error order exits in resolver
      order: DEFAULT_ORDER,
    },
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return {
    error,
    ...rest,
  };
};

export { useCompaniesIndustries, DEFAULT_ORDER };
